<template>
  <div class="wrapper">
    <!-- 青创联盟 -->
    <b-container>
      <b-row class="intro">
        <div class="left">
          <p class="bname">{{ this.introInfo.cnName }}</p>
          <p class="sname">{{ this.introInfo.enName }}</p>
        </div>
        <p class="about">{{ this.introInfo.about }}</p>
      </b-row>
      <layoutimg :cols="6" :md="4" :dataList="dataList"></layoutimg>
    </b-container>
  </div>
</template>
<script>
import layoutimg from "@/forumcomponents/aboutList";
export default {
  components: {
    layoutimg,
  },
  data() {
    return {
      type: 5, //青创联盟
      dataList: [],
      childrenType: 3, //委员
      introInfo: {},
    };
  },
  created() {
    this.getAboutIntroInfo();
    this.getAboutList();
  },
  methods: {
    getAboutIntroInfo() {
      this.$forumApi
        .aboutIntroInfo({
          type: this.type,
        })
        .then((res) => {
          if (res.code == 200) {
            this.introInfo = res.data;
          }
        });
    },
    getAboutList() {
      this.$forumApi
        .aboutList({
          type: this.type,
          childrenType: this.childrenType,
        })
        .then((res) => {
          if (res.code == 200) {
            res.data.forEach((item) => {
              var rank = [];
              if (item.introduce != null) {
                let intro = JSON.parse(item.introduce);
                intro.forEach((item) => {
                  rank.push(item.date);
                });
              }
              this.dataList.push({
                title: item.name,
                titleImg: item.sysFilePhotoIdUrl,
                rank: rank,
                id: item.id,
                url: item.url,
              });
            });
          }
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.intro {
  background: #f5f5f5;
  margin: 2rem 0rem;
  padding: 2rem 0rem 2rem 0rem;
}

.intro * {
  display: inline-block;
}

.bname {
  height: 1rem;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  width: max-content;
}

.sname {
  font-size: 0.9rem;
  color: #999;
  text-align: left;
  line-height: 4rem;
}

.ltxt {
  float: left;
  text-align: left;
  height: 100%;
  padding: 30px;
  background: #f5f5f5;
}

.left {
  flex: 1.2;
  display: flex;
  flex-direction: column;
  padding-left: 2rem;
}

p {
  margin-bottom: 0;
}

.about {
  flex: 3;
  line-height: 1.7rem;
  font-size: 1rem;
  display: flex;
  align-items: center;
  padding: 0rem 2rem 0rem 0em;
}

@media (max-width: 768px) {
  .intro {
    display: block;
  }

  .about {
    flex: 2;
    font-size: 1px;
    line-height: 1.7rem;
    padding: 0rem;
    color: #4a4a4a;
    transform: scale(0.88);
  }

  .intro {
    background: #f5f5f5;
    margin: 2rem 0rem;
    padding: 2rem 0rem 1rem 0rem;
  }

  .left {
    flex: 0.25;
    display: flex;
    flex-direction: column;
    align-items: start;
    height: 4.5rem;
  }

  .bname {
    font-size: 1rem;
    padding: 0.5rem 8px 0px 0rem;
  }

  .sname {
    font-size: 0.2rem;
    color: #999;
    text-align: center;
    padding: 0.2rem 1rem 0rem 0rem;
    height: 4rem;
  }
}
</style>